import axios from './http';
import { CancelTokenSource } from 'axios';
import { UpsertVatDto, VatDto, VatSearchRequest } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/vats`;

export const getAllVats = (source: CancelTokenSource): Promise<Array<VatDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then((response) => response.data);
};

export const searchVatGroups = async (vatSearchRequest: Partial<VatSearchRequest>,
                                        source: CancelTokenSource) => {
  try {
    return axios
        .post(`${apiUri}/search`, vatSearchRequest, {cancelToken: source.token})
        .then(response => response.data);
  } catch (e) {
  }
};

export const findVatGroupById = (id: number, source: CancelTokenSource): Promise<UpsertVatDto> => {
  return axios
      .get(`${apiUri}/${id}`,{cancelToken: source.token})
      .then( response => response.data)
};

export const addVatGroup = (upsertVatDto: Partial<UpsertVatDto>,
                            source: CancelTokenSource): Promise<VatDto> => {
  return axios
      .post(apiUri, upsertVatDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editVatGroup = (id: number, upsertVatDto: Partial<UpsertVatDto>,
                             source: CancelTokenSource): Promise<VatDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertVatDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteVatGroup = (id: number, source: CancelTokenSource): Promise<VatDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};
